import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'Fired when a non-Enterprise admin clicks an Audit Logs upsell CTA',
  name: 'audit_log_upsell_cta_clicked',
  params: [
    {
      description: 'Workspace the upsell was shown for',
      name: 'workspace_id',
      required: true,
      type: 'string',
    },
    {
      description: 'Which upsell control was clicked',
      name: 'cta_type',
      required: true,
      type: 'enum',
      values: ['link', 'badge'],
    },
  ],
};

export default META;
